// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"542":"DesktopNonResponsiveRootWidget","806":"DesktopResponsiveRootWidget","845":"SignupRootWidget","990":"MobileRootWidget"}[chunkId] || chunkId) + ".chunk.min.css";
};